import React from 'react'
import { Link } from 'gatsby'

export const translations = {
  de: {
    headline: 'Cookie Einstellungen',
    introText:
      'Wir nutzen Cookies auf unserer Website. Einige von ihnen sind essenziell, während andere uns helfen, diese Website und deine Erfahrung zu verbessern.',
    cookieLink: 'Cookie Richtlinien',
    acceptAll: 'Alle Cookies akzeptieren',
    acceptSelection: 'Nur Auswahl speichern',
    on: 'Ein',
    off: 'Aus',
    imprint: 'Impressum',
    privacy: 'Datenschutz',
    cookies: {
      required: {
        title: 'Notwendige Cookies',
        description: (
          <>
            Diese Cookies sind unerlässlich, damit Sie die Website nutzen und ihre Funktionen nutzen können. Sie können
            nicht abgeschaltet werden. Sie werden als Antwort auf Anfragen von Ihnen gesetzt, wie z.B. das Einstellen
            Ihrer Datenschutzeinstellungen, das Einloggen oder das Ausfüllen von Formularen.{' '}
            <Link to="/cookie-policy#cookielist">Hier</Link> findest du eine Liste der von uns verwendeten, notwendigen
            Cookies.
          </>
        ),
      },
      marketing: {
        title: 'Cookies für Marketing',
        description: (
          <>
            Diese Cookies ermöglichen es dem Betreiber dieser Website (dieses Funnels), zukünftige Interessenten zu
            identifizieren und die Verkaufs- und Marketinginteraktionen mit ihnen zu personalisieren. Die Informationen
            von Marketing Cookies können an andere Werbefirmen weitergegeben werden.{' '}
            <Link to="/cookie-policy#cookielist">Hier</Link> findest du eine Liste der von uns verwendeten, notwendigen
            Cookies.
          </>
        ),
      },
      analytics: {
        title: 'Cookies für Analyse',
        description: (
          <>
            Diese Cookies sammeln Informationen, die dem Betreiber dieser Website (dieses Funnels) helfen zu verstehen,
            wie die Funnels genutzt werden oder wie effektiv die Marketingkampagnen sind. Außerdem können Sie helfen die
            Funnels für Dich anzupassen. Hier findest du eine Liste der von uns verwendeten Analyse Cookies.{' '}
            <Link to="/cookie-policy#cookielist">Hier</Link> findest du eine Liste der von uns verwendeten, notwendigen
            Cookies.
          </>
        ),
      },
      media: {
        title: 'Cookies für Medien',
        description: (
          <>
            Diese Cookies werden verwendet um externe Medien auf dieser Website (in dem Funnel) anzuzeigen und somit
            Content bereitzustellen. Hierbei handelt es sich um Third-Party-Cookies.{' '}
            <Link to="/cookie-policy#cookielist">Hier</Link> findest du eine Liste der von uns verwendeten, notwendigen
            Cookies.
          </>
        ),
      },
    },
  },
  en: {
    headline: 'Cookie Settings',
    introText:
      'We are using cookies on this website. Some of them are essential, while others help us improve this website and your experience.',
    cookieLink: 'Cookie policies',
    acceptAll: 'Accept all Cookies',
    acceptSelection: 'Only accept selection',
    on: 'On',
    off: 'Off',
    imprint: 'Imprint',
    privacy: 'Privacy',
    cookies: {
      required: {
        title: 'Essential Cookies',
        description: (
          <>
            These cookies are essential to enable you to use the website and its functions. They cannot be turned off.
            They are set in response to requests from you, such as setting your privacy preferences, logging in or
            filling out forms. <Link to="/cookie-policy#cookielist">Here</Link> you will find a list of the necessary
            cookies we use.
          </>
        ),
      },
      marketing: {
        title: 'Cookies for marketing',
        description: (
          <>
            These cookies enable the operator of this website (this funnel) to identify prospective customers and
            personalize sales and marketing interactions with them. The information from marketing cookies may be shared
            with other advertising companies. <Link to="/cookie-policy#cookielist">Here</Link> you will find a list of
            the necessary cookies we use.
          </>
        ),
      },
      analytics: {
        title: 'Cookies for analytics',
        description: (
          <>
            These cookies collect information that helps the operator of this website (this funnel) to understand how
            the funnels are being used or how effective the marketing campaigns are. They can also help customize the
            Funnels for you. <Link to="/cookie-policy#cookielist">Here</Link> you will find a list of the necessary
            cookies we use.
          </>
        ),
      },
      media: {
        title: 'Cookies for media',
        description: (
          <>
            These cookies are being used to display external media on this website (in this funnel) and thus provide
            content. These are third party cookies. <Link to="/cookie-policy#cookielist">Here</Link> you will find a
            list of the necessary cookies we use.
          </>
        ),
      },
    },
  },
}

export default translations
